import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICON } from '@core/util/icon';
import { MatterFileType } from '@models/matter';
import { TestHooks } from './file-select.hooks';

@Component({
	selector: 'app-matter-file-type-select',
	templateUrl: './file-select.component.html',
	styleUrls: ['./file-select.component.scss'],
	standalone: false,
})
export class FileSelectComponent {
	testHooks = TestHooks;
	public ICON = ICON;

	@Input() fileTypes: MatterFileType[] = [
		MatterFileType.PURCHASE,
		MatterFileType.SALE,
		MatterFileType.REFINANCE,
	];
	@Input() goBackText;
	@Output() fileTypeSelected: EventEmitter<MatterFileType> =
		new EventEmitter<MatterFileType>();
	@Output() onGoBack: EventEmitter<void> = new EventEmitter();

	setFileType(fileType: MatterFileType) {
		this.fileTypeSelected.emit(fileType);
	}

	goBack() {
		this.onGoBack.emit();
	}
}
